import { render, staticRenderFns } from "./sales-by-price-range.vue?vue&type=template&id=6a377e7c&scoped=true&"
import script from "./sales-by-price-range.vue?vue&type=script&lang=js&"
export * from "./sales-by-price-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a377e7c",
  null
  
)

export default component.exports